import SelectionState from 'state/selections/SelectionState';

export const deleteDefinition = (definitions, definition) => {
  const uncommittedIdx = definitions[SelectionState.UNCOMMITTED].findIndex(({ key }) => key === definition.key);
  const committedIdx = definitions[SelectionState.COMMITTED].findIndex(({ key }) => key === definition.key);
  if (uncommittedIdx > -1) {
    definitions[SelectionState.UNCOMMITTED].splice(uncommittedIdx, 1);
  }
  if (committedIdx > -1) {
    definitions[SelectionState.COMMITTED].splice(committedIdx, 1);
  }
  return definitions;
}